import { Text } from "@chakra-ui/react";

export const SalesCannotCloseSaleWithNotEnoughPaidError = () => {
  return <Text>Il y a un reste à régler</Text>;
};
